/**
 * @copyright 2024-2026 David Baugh
 * @license Proprietary - All Rights Reserved
 * Unauthorized copying, modification, or distribution is strictly prohibited.
 */

// Version checking utility to detect when app needs refresh
export const APP_VERSION = process.env.REACT_APP_VERSION || Date.now().toString();

export const checkForUpdates = async () => {
  try {
    // Fetch version from the existing API endpoint
    const response = await fetch('/api/version?' + Date.now(), {
      cache: 'no-store'
    });

    if (!response.ok) {
      console.warn('Could not check for app updates');
      return { hasUpdate: false };
    }

    const serverVersion = await response.json();
    const currentVersion = localStorage.getItem('app_version') || '0';

    console.log('Version check:', { currentVersion, serverVersion: serverVersion.version });

    // Store current version on first load
    if (!localStorage.getItem('app_version')) {
      localStorage.setItem('app_version', serverVersion.version.toString());
      return { hasUpdate: false }; // Don't prompt on first load
    }

    return {
      hasUpdate: serverVersion.version.toString() !== currentVersion.toString(),
      currentVersion,
      serverVersion: serverVersion.version,
      updateMessage: "New features and bug fixes are available"
    };

  } catch (error) {
    console.error('Error checking for updates:', error);
    return { hasUpdate: false };
  }
};

export const markVersionAsUpdated = (version) => {
  localStorage.setItem('app_version', version.toString());
};

export const forceRefresh = () => {
  markVersionAsUpdated();
  window.location.reload(true);
};